/* Haye Nii (task 35): makes the free-shipping line true for the visitor (snippets/hn-free-shipping.liquid).
   Shopify's own IP lookup (/browsing_context_suggestions.json) gives the visitor's real country, once per visit
   (kept in sessionStorage). India: the line's box is hidden (India pays 3000 INR, so no shipping claim).
   Store default country (Canada) but the visitor is elsewhere: "Free shipping to <their country>".
   Lookup failed while on the default country: the top bar says "Free shipping to Canada, USA, UK & more". */
(function () {
  if (window.hnFreeShipReady) return;
  window.hnFreeShipReady = true;

  var DEFAULT_COUNTRY = 'CA';
  var FALLBACK = 'Free shipping to Canada, USA, UK & more';
  var NAMES = { US: 'the USA', GB: 'the UK', AE: 'the UAE', NL: 'the Netherlands', PH: 'the Philippines' };
  var KEY = 'hn_geo_country';
  var here = (window.Shopify && window.Shopify.country) || '';

  var apply = function (code, name) {
    var hid = false;
    document.querySelectorAll('[data-hn-ship]').forEach(function (el) {
      if (code === 'IN') {
        var box = el.closest('[data-hn-ship-box]') || el;
        if (box.classList.contains('slider__slide')) { box.remove(); hid = true; } // an announcement slide: take it out
        else if (!box.hidden) box.hidden = true;
        return;
      }
      if (here !== DEFAULT_COUNTRY) return; // the store already shows the visitor's own market
      if (code === DEFAULT_COUNTRY) el.textContent = 'Free shipping to Canada';
      else if (code && (NAMES[code] || name)) el.textContent = 'Free shipping to ' + (NAMES[code] || name);
      else if (el.hasAttribute('data-hn-ship-wide')) el.textContent = FALLBACK; // small spots keep "... to Canada" (true here)
    });
    if (hid) {
      // a hidden announcement slide: let the theme's slider count its slides again
      document.querySelectorAll('slideshow-component').forEach(function (s) {
        try {
          var slides = s.querySelectorAll('[id^="Slide-"]');
          slides.forEach(function (sl, i) { sl.setAttribute('aria-label', (i + 1) + ' of ' + slides.length); });
          s.sliderItems = slides;
          if (s.slider) s.sliderFirstItemNode = s.slider.querySelector('.slideshow__slide');
          if (typeof s.initPages === 'function') s.initPages();
        } catch (e) { /* ignore */ }
      });
    }
  };

  function run() {
    if (!document.querySelector('[data-hn-ship]')) return;
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { /* private mode */ }
    if (saved && saved.c) { apply(saved.c, saved.n); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country;
        var code = c && typeof c.handle === 'string' ? c.handle.toUpperCase() : '';
        var name = (c && c.name) || '';
        if (!/^[A-Z]{2}$/.test(code)) throw new Error('no country');
        try { sessionStorage.setItem(KEY, JSON.stringify({ c: code, n: name })); } catch (e) { /* private mode */ }
        apply(code, name);
      })
      .catch(function () { apply('', ''); });
  }

  var known = null;
  var realApply = apply;
  apply = function (code, name) { known = { c: code, n: name }; realApply(code, name); };

  // The cart page and drawer redraw their HTML after a change: fix new free-shipping lines too
  function watch() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (list) {
      if (!known) return;
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-hn-ship') || n.querySelector('[data-hn-ship]'))) {
            realApply(known.c, known.n);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() { run(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
